/*
 * method.js
 * Written by: Connor Taylor
 *
 * Wraps the call to Piwik, our event logging system. This checks to make sure
 * the window object and the piwik queue are available before logging events
 */

/**
 * Wrapper for calling `window._paq.push()` to log Piwik data. Ensures that
 * `window._paq` is defined before pushing events onto it.
 *
 * @param  {string} type The type of piwik method
 * @param  {Array} data The data for the given piwik method
 *
 * @public
 * @author Connor Taylor
 *
 * @example
 * method(`setCustomUrl`, [`http://foo.bar.com`]);
 * method(`trackPageView`, []);
 */
var method = function method(type, data) {
  /* eslint-disable */
  if (window && window._paq) {
    window._paq.push([type].concat(data));
  }
  /* eslint-enable */

};
/** @component */


export default method;